/**
 * 命名格式：platform.业务场景描述(xx_yy_zz).[兼容版本号 v1].[唯一标识xxx].[唯一标识yyy]
 */

export const LOCAL_STORAGE = {
    UPGRADE_TIP: 'jdy.upgrade_tip', // 升级提示
    USER_COOKIE_ID: 'jdy.user.cookieId', // 记录未注册用户（一个UUID值）
    FX_LOCAL_UUID: '__fx__local__uuid__', // fx-tracker-web 中记录的 uuid，暂时先写死 key，后续可改为从包中导出
    SIGN_IN: {
        ACCOUNT: 'jdy.signin.account', // 是否为账号登录，如果否则为验证码登录
        TYPE: 'jdy.signin.type', // 登录方式
        PHONE_AREA: 'jdy.signin.phone.area' // 手机区号
    },
    SIGN_IN_CORP_TYPE: 'platform.signin_corp_type', // 租户登录页登录方式
    MEMBER_STATUS_FILTER: 'jdy.member_status_filter', // 通讯录成员筛选状态-部门对应
    CONTACT_LAYOUT_WIDTH: 'jdy.contact.layout.width', // 通讯录左侧menu宽度,
    PRIVATE_PLUGIN_DEBUG_CODE: 'jdy.private.debug.code', // 自建插件调试代码,
    OPEN_PLATFORM_ROUTER: 'jdy.open_platform_router', // 开放平台路由缓存，
    ADMIN_NAV_COLLAPSED: 'platform.admin_nav_collapsed', // 管理后台左侧导航收起状态
    MEMBER_TABLE_SEARCH_RANGE: 'platform.member_table_search_range', // 成员表格搜索范围
    /** 数据源同步表云币 instruction 手动关闭记录 */
    DATA_SOURCE_COIN_INSTRUCTION_CLOSED: 'jdy.data_source_coin_instruction_closed'
};

// todo skye 下掉迁移
export const LOCAL_STORAGE_MIGRATE = {
    LANG: 'fx.lang', // 语言
    USER_COOKIE_ID: 'jdy.user_cookie_id', // 记录未注册用户（一个UUID值）
    SIGN_IN_ACCOUNT: 'jdy.signin_account', // 是否为账号登录，如果否则为验证码登录
    SIGN_IN_TYPE: 'jdy.signin_type', // 登录方式
    SIGN_IN_PHONE_AREA: 'jdy.signin_phone_area',
    INVITE_MEMBER: 'jdy.invite_member', // 成员邀请引导
    MEMBER_STATUS_FILTER: 'jdy.member_status_filter', // 通讯录成员筛选状态-部门对应
    MEMBER_FREEZE_TIP_HIDE: 'jdy.member_freeze_tip_hide', // 24x小时内不显示成员启用/停用popConfirm
    CORP_COOP_PUBLIC_LINK_TIP: 'jdy.corp_coop_public_link_tip',
    CONTACT_LAYOUT_WIDTH: 'jdy.contact_layout_width', // 通讯录左侧menu宽度,
    PLUGIN_PRIVATE_DEBUG_CODE: 'jdy.plugin_private_debug_code', // 自建插件调试代码，
    /** 试用插件即将过期 */
    TRIAL_DUE_PLUGIN: 'jdy.trial_due_plugin'
};
